module.exports = __webpack_public_path__ + "img/vertical_4_4_4.4d175697.png";